import { openDB } from 'idb';                                                    // small IndexedDB wrapper :contentReference[oaicite:3]{index=3}
const dbp = openDB('voice-queue', 1, {
  upgrade(db) { db.createObjectStore('outbox', { keyPath: 'id', autoIncrement: true }); }
});
export const enqueueRecording = blob =>
  dbp.then(db => db.add('outbox', { blob, ts: Date.now() }));

export const dequeueAll = async () => {
  const db = await dbp;
  const tx = db.transaction('outbox', 'readwrite');
  const all = await tx.store.getAll();
  await tx.store.clear();
  await tx.done;
  return all;
};
